import React from 'react';
import { Redirect } from 'react-router-dom';

import { permissionCheck } from 'helpers/permissionCheckHelper';
//
import NotifList from 'pages/NotifList'
import UserList from 'pages/UserList';
import DepartmentList from 'pages/DepartmentList';
import ContractorList from 'pages/ContractorList';
import GroupManagement from 'pages/GroupManagement';
import TaskListRouter from 'pages/TaskList';
import CompanyList from 'pages/CompanyList';
import UserTrafficList from 'pages/UserTrafficList';
import DailyReportRouter from 'pages/DailyReport';
import DailyLoadingPointRouter from 'pages/DailyLoadingPoint';
import ReportTCM from 'pages/ReportTCM';
import ReportIMM from 'pages/ReportIMM';
import ReportBargeChecklist from 'pages/ReportBargeChecklist';
import DataValidationRouter from 'pages/DataValidation';
import ActualLoading from 'pages/ActualLoading';
import BlastingReportList from 'pages/BlastingReport';
//
import {
  ROUTE_DASHBOARD,
  ROUTE_DASH_USERS,
  ROUTE_DASH_DEPARTMENTS,
  ROUTE_DASH_CONTRACTORS,
  ROUTE_DASH_GROUPS,
  ROUTE_DASH_TASKS,
  ROUTE_NOTIFICATIONS,
  ROUTE_DASH_COMPANIES,
  ROUTE_DASH_USER_TRAFFIC_LOG,
  ROUTE_DASH_REPORT_TCM,
  ROUTE_DASH_REPORT_BEK,
  ROUTE_DASH_DAILY_LOADING_POINT,
  ROUTE_DASH_REPORT_IMM,
  ROUTE_DASH_REPORT_BARGE_CHECKLIST,
  ROUTE_DASH_DATA_VALIDATION,
  ROUTE_DASH_ACTUAL_LOADING,
  ROUTE_DASH_REPORT_TRIP_COUNT,
  ROUTE_DASH_BLASTING_REPORT,
  ROUTE_DASH_STOCK_OPNAME
} from 'fixtures/routes';

import {
  reportRead,
  BEKReportRead,
  IMMReportRead,
  taskRead
} from 'fixtures/permissions';
import ReportTripCount from 'pages/ReportTripCount/index';
import StockOpname from 'pages/StockOpname/index';

// list of Dashboard child routes
const routes = permissions => {
  let landingRoute = ROUTE_DASH_USERS

  if (permissionCheck(permissions, reportRead)) {
    landingRoute = ROUTE_DASH_REPORT_TCM
  } else if (permissionCheck(permissions, BEKReportRead)) {
    landingRoute = ROUTE_DASH_REPORT_BEK
  } else if (permissionCheck(permissions, IMMReportRead)) {
    landingRoute = ROUTE_DASH_REPORT_IMM
  } else if (permissionCheck(permissions, taskRead)) {
    landingRoute = ROUTE_DASH_TASKS
  }

  return [
    {
      path: '/',
      exact: true,
      main: () => <Redirect to={`/${ROUTE_DASHBOARD}/${landingRoute}`} />,
      isProtected: true
    },
    {
      path: `/${ROUTE_DASH_USERS}`,
      main: () => <UserList />,
      isProtected: true
    },
    {
      path: `/${ROUTE_DASH_COMPANIES}`,
      main: () => <CompanyList />,
      isProtected: true
    },
    {
      path: `/${ROUTE_DASH_DEPARTMENTS}`,
      main: () => <DepartmentList />,
      isProtected: true
    },
    {
      path: `/${ROUTE_DASH_CONTRACTORS}`,
      main: () => <ContractorList />,
      isProtected: true
    },
    {
      path: `/${ROUTE_DASH_GROUPS}`,
      main: () => <GroupManagement />,
      isProtected: true
    },
    {
      path: `/${ROUTE_DASH_TASKS}`,
      main: () => <TaskListRouter />,
      isProtected: true
    },
    {
      path: `/${ROUTE_DASH_USER_TRAFFIC_LOG}`,
      main: () => <UserTrafficList />,
      isProtected: true
    },

    {
      path: `/${ROUTE_DASH_REPORT_TCM}`,
      main: () => <ReportTCM />,
      isProtected: true
    },
    {
      path: `/${ROUTE_DASH_REPORT_BEK}`,
      main: () => <DailyReportRouter />,
      isProtected: true
    },
    {
      path: `/${ROUTE_DASH_DAILY_LOADING_POINT}`,
      main: () => <DailyLoadingPointRouter />,
      isProtected: true
    },
    {
      path: `/${ROUTE_DASH_REPORT_IMM}`,
      main: () => <ReportIMM />,
      isProtected: true
    },
    {
      path: `/${ROUTE_DASH_REPORT_BARGE_CHECKLIST}`,
      main: () => <ReportBargeChecklist />,
      isProtected: true
    },
    {
      path: `/${ROUTE_DASH_REPORT_TRIP_COUNT}`,
      main: () => <ReportTripCount />,
      isProtected: true
    },
    {
      path: `/${ROUTE_DASH_DATA_VALIDATION}`,
      main: () => <DataValidationRouter />,
      isProtected: true
    },
    {
      path: `/${ROUTE_DASH_ACTUAL_LOADING}`,
      main: () => <ActualLoading />,
      isProtected: true
    },
    {
      path: `/${ROUTE_DASH_BLASTING_REPORT}`,
      main: () => <BlastingReportList />,
      isProtected: true
    },
    {
      path: `/${ROUTE_NOTIFICATIONS}`,
      main: () => <NotifList />,
      isProtected: true
    },
    {
      path: `/${ROUTE_DASH_STOCK_OPNAME}`,
      main: () => <StockOpname />,
      isProtected: true
    },
  ]
}

export default routes;
